// Utils
import { convertPercentToHex } from './convertPercentToHex';
/**
 * @description Adds a percent of opacity to a colour.
 *
 * @returns {string} The colour value with opacity
 */
export var appendOpacityValueToColour = function (colour, percent) {
    return "".concat(colour).concat(convertPercentToHex(percent));
};
//# sourceMappingURL=appendOpacityValueToColour.js.map